import { apiClient } from '../../axios';
import { PutAffiliateProgramSignUpData } from './types';

export const putAffiliateProgramSignUpApi = (data: PutAffiliateProgramSignUpData) =>
  apiClient.put('/v1/affiliate-program/signup', data);
